import updateOnBoardingAction from "../../../actions/siteadmin/updateOnBoardingAction";

async function submit(values, dispatch) {
    dispatch(updateOnBoardingAction(values));
}

export default submit;